// Constants
export const afiliado_inclusiones = () => {
  return {
    afiliado_inclusiones: {
      id: {
        namepath: ['afiliacion_inclusiones'],        
        type: "number",
        label: "id",
        placeholder: "",
        description: "",
        validate: "",
        datatype: {
          type: "input",
          disabled: true,
          predeterminate: "",
        }
      },
      id_afiliado_beneficiarios: {
        type: "text",
        label: "datos afiliado",
        placeholder: "",
        namepath: ['afiliacion_inclusiones'],
        description: "",
        validate: "",
        datatype: {
          type: "select",
          disabled: false,
          predeterminate: null,
          list: "datos_razon",
          label: 'name'
        }
      }, 
      id_datos_afiliado: {
        type: "text",
        label: "datos afiliado",
        placeholder: "",
        namepath: ['afiliacion_inclusiones'],
        description: "",
        validate: "",
        datatype: {
          type: "select",
          disabled: false,
          predeterminate: "",
          list: "datos_razon",
          label: 'name'
        }
      },    
      id_info_afiliacion: {
        type: "text",
        label: "Registro afiliación",
        placeholder: "",
        namepath: ['afiliacion_inclusiones'],
        description: "",
        validate: "",
        datatype: {
          type: "input",
          disabled: true,
          predeterminate: "",
        }
      },
      id_list_users: {
        type: "text",
        label: "Usuario",
        placeholder: "",
        namepath: ['afiliacion_inclusiones'],
        description: "",
        validate: "required",
        datatype: {
          type: "select",
          disabled: false,
          predeterminate: '',
          list: "list_users",
          label: 'name',
        }
      },
      name: {
        type: "text",
        label: "Nombre del beneficiario",
        placeholder: "",
        namepath: ['afiliacion_inclusiones'],
        description: "",
        validate: "required",
        datatype: {
          type: "input",
          disabled: false,
          predeterminate: "",
        }
      },
      archivo_radicado: {
        namepath: ['afiliacion_inclusiones'],
        type: 'text',
        label: 'Seleccionar documento',
        placeholder: '',
        description: 'documento',
        validate: '',
        datatype: {
          type: 'file', 
          disabled: false,
          predeterminate: [],
        }
      },
      archivo: {
        namepath: ['afiliacion_inclusiones'],
        type: 'text',
        label: 'Seleccionar documento',
        placeholder: '',
        description: 'documento',
        validate: '',
        datatype: {
          type: 'file', 
          disabled: false,
          predeterminate: [],
        }
      },
      direccion: {
        namepath: ['afiliacion_inclusiones'],
        type: 'text',
        label: 'Dirección',
        placeholder: '',
        description: 'documento',
        validate: '',
        datatype: {
          type: 'input', 
          disabled: false,
          predeterminate: '',
        }
      },
      radicado: {
        namepath: ['afiliacion_inclusiones'],
        type: 'text',
        label: 'radicado',
        placeholder: '',
        description: 'documento',
        validate: 'required',
        datatype: {
          type: 'date', 
          disabled: false,
          predeterminate: '',
        }
      },
      observacion: {
        namepath: ['afiliacion_inclusiones'],
        type: 'text',
        label: 'Observación',
        placeholder: '',
        description: 'Observación',
        validate: '',
        datatype: {
          type: 'input', 
          disabled: false,
          predeterminate: null,
        }
      },
      nota_delete: {
        type: "text",
        label: "Nota",
        placeholder: "",
        namepath: ['afiliacion_inclusiones'],
        description: "",
        validate: "required",
        datatype: {
          type: "input",
          disabled: false,
          predeterminate: null
        }
      },
    }
  }
}


